<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14um7N6/tc-custom/9781399070775.jpg?1725275783932" alt="This image is the cover for the book Railways and Industry on the Brecon & Merthyr, South Wales Valleys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Railways and Industry on the Brecon & Merthyr, South Wales Valleys
      </h1>
      <p class="bookDescription body article font2">
        <p>This book on the Brecon &amp; Merthyr, deals with the section from Bargoed to Pontsticill Junction, covering the line built by the B&amp;M to join onto the section running north from Bargoed built by the Rhymney Railway, much dominated at the time by nearby Dowlais Ironworks. Included is the short section from Pant to Dowlais Central. It contains photographs of every location along the line, including many that have not before been published. The volume includes a fascinating account of the Pantywaun Marshalling Yard, operative until Dowlais Ironworks ceased production, when the B&amp;M ran freight services to and from Pantywaun, before the many collieries and levels in the area were closed almost overnight and the location finally obliterated under the development of Cwmbargoed Opencast.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Hodge, R. J. Caston
      </h2>
      
      <p class="authorDescription body article">JOHN HODGE is a former railway manager during the 1960s who, since retirement in 1992, has produced many articles and books on South Wales railways.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41a1ccdd